<template>
  <div class="q-pa-lg">
    <!-- Header -->
    <div class="row justify-between items-center q-mb-lg">
      <div class="row justify-between align-center">
        <p class="text-h6 text-brand-1 text-weight-bolder">
          Detalhe do Contrato
        </p>
      </div>
      <div class="col-auto">
        <q-btn
          flat
          icon="arrow_back"
          label="Voltar"
          color="grey"
          @click="voltarParaListagem"
          class="q-mr-sm"
        />
      </div>
    </div>

    <q-expansion-item
      :disable="edicaoHabilitada"
      style="border: 1px solid #eee"
    >
      <template v-slot:header>
        <q-item-section>
          <section class="row q-gutter-md">
            <div class="col-md-3 col-sm-6 col-xs-12">
              <div class="input-new-design">
                <label class="input-label"
                  >Número do Contrato
                  <span v-if="edicaoHabilitada" class="text-brand-2"
                    >(Editavel)</span
                  ></label
                >
                <q-input
                  v-model="contrato.contractNumber"
                  :readonly="!edicaoHabilitada"
                  dense
                  outlined
                  class="input-field"
                />
              </div>
            </div>
            <div class="col-md-3 col-sm-6 col-xs-12">
              <div class="input-new-design">
                <label class="input-label">Fornecedor</label>

                <q-input
                  v-model="vendorName"
                  readonly
                  dense
                  outlined
                  class="input-field"
                />
              </div>
            </div>
            <div class="col-md-3 col-sm-6 col-xs-12">
              <div class="input-new-design">
                <label class="input-label">Tipo de Fornecimento </label>
                <!--<q-select
                  v-model="contrato.supplyName"
                  v-if="edicaoHabilitada"
                  dense
                  class="input-field"
                  outlined
                  :options="suppliesOptions"
                  option-label="name"
                  option-value="name"
                  map-options
                  emit-value
                  use-input
                  @filter="filterFn"
                  :display-value="
                    contrato?.supplyName?.name?.length > 28
                      ? `${contrato?.supplyName?.name?.substring(0, 28)}..`
                      : contrato?.supplyName?.name
                  "
                  ><q-tooltip v-if="contrato?.supplyName?.name">
                    {{ contrato?.supplyName?.name }}
                  </q-tooltip></q-select
                >-->
                <q-input
                  v-model="contrato.supplyName"
                  readonly
                  dense
                  outlined
                  class="input-field"
                />
              </div>
            </div>
          </section>
        </q-item-section>
      </template>

      <!-- Cabeçalho com Dados Principais -->
      <q-card class="q-mb-lg" flat bordered>
        <q-card-section>
          <div class="text-h6 text-weight-bold q-mb-md">
            <q-icon name="description" class="q-mr-sm" />
            Informações Adicionais
          </div>
          <div class="row q-gutter-md">
            <div class="col-md-3 col-sm-6 col-xs-12">
              <div class="input-new-design">
                <label class="input-label">CNPJ</label>
                <q-input
                  v-model="vendorCnpj"
                  readonly
                  dense
                  outlined
                  class="input-field"
                  mask="##.###.###/####-##"
                />
              </div>
            </div>
          </div>
          <div class="row q-gutter-md q-mt-md">
            <div class="col-md-3 col-sm-6 col-xs-12">
              <div class="input-new-design">
                <label class="input-label"
                  >Data Início
                  <span v-if="edicaoHabilitada" class="text-brand-2"
                    >(Editavel)</span
                  ></label
                >
                <q-input
                  v-model="contrato.startDate"
                  :readonly="!edicaoHabilitada"
                  dense
                  outlined
                  class="input-field"
                  type="date"
                />
              </div>
            </div>
            <div class="col-md-3 col-sm-6 col-xs-12">
              <div class="input-new-design">
                <label class="input-label"
                  >Data Término
                  <span v-if="edicaoHabilitada" class="text-brand-2"
                    >(Editavel)</span
                  ></label
                >
                <q-input
                  v-model="contrato.endDate"
                  :readonly="!edicaoHabilitada"
                  dense
                  outlined
                  class="input-field"
                  type="date"
                />
              </div>
            </div>
            <div class="col-md-3 col-sm-6 col-xs-12">
              <div class="input-new-design">
                <label class="input-label"
                  >Número Aditivo
                  <span v-if="edicaoHabilitada" class="text-brand-2"
                    >(Editavel)</span
                  >
                </label>
                <q-input
                  v-model="contrato.aditiveNumber"
                  :readonly="!edicaoHabilitada"
                  dense
                  outlined
                  class="input-field"
                  type="number"
                />
              </div>
            </div>
            <div class="col-md-3 col-sm-6 col-xs-12">
              <div class="input-new-design">
                <label class="input-label"
                  >Valor Total
                  <span v-if="edicaoHabilitada" class="text-brand-2"
                    >(Editavel)</span
                  ></label
                >
                <q-input
                  v-model="contrato.totalValue"
                  :readonly="!edicaoHabilitada"
                  dense
                  outlined
                  class="input-field"
                  prefix="R$"
                  placeholder="0,00"
                  @input="formatarInput"
                  @blur="formatarValorFinal"
                />
              </div>
            </div>
            <div class="col-md-3 col-sm-6 col-xs-12">
              <div class="input-new-design">
                <label class="input-label">Valor Vinculado</label>
                <q-input
                  :model-value="formatarMoeda(contrato.linkedValue || 0)"
                  readonly
                  dense
                  outlined
                  class="input-field bg-grey-2"
                  :color="(contrato.linkedValue || 0) > 0 ? 'positive' : 'grey'"
                />
              </div>
            </div>
            <div class="col-md-3 col-sm-6 col-xs-12">
              <div class="input-new-design">
                <label class="input-label">Valor Disponível</label>
                <q-input
                  :model-value="formatarMoeda(contrato.availableValue || 0)"
                  readonly
                  dense
                  outlined
                  class="input-field bg-grey-2"
                  :color="getValorDisponivelColor(contrato.availableValue)"
                />
              </div>
            </div>
            <div class="col-md-3 col-sm-6 col-xs-12">
              <div class="input-new-design">
                <label class="input-label">Status</label>
                <q-input
                  v-model="contrato.status"
                  readonly
                  dense
                  outlined
                  class="input-field"
                />
              </div>
            </div>
          </div>
          <div class="row q-gutter-md q-mt-md">
            <div class="col-md-3 col-sm-6 col-xs-12">
              <div class="input-new-design">
                <label class="input-label">Usuário Criador</label>
                <q-input
                  v-model="userName"
                  readonly
                  dense
                  outlined
                  class="input-field"
                />
              </div>
            </div>
            <div class="col-md-3 col-sm-6 col-xs-12">
              <div class="input-new-design">
                <label class="input-label">Matricula Usuário</label>
                <q-input
                  v-model="userSap"
                  readonly
                  dense
                  outlined
                  class="input-field"
                />
              </div>
            </div>
            <div class="col-md-4 col-sm-6 col-xs-12">
              <div class="input-new-design">
                <label class="input-label">Data Criação</label>
                <q-input
                  v-model="contrato.createdAt"
                  readonly
                  dense
                  outlined
                  class="input-field"
                />
              </div>
            </div>
            <div class="col-md-4 col-sm-6 col-xs-12">
              <div class="input-new-design">
                <label class="input-label">Data Atualização</label>
                <q-input
                  v-model="contrato.updatedAt"
                  readonly
                  dense
                  outlined
                  class="input-field"
                />
              </div>
            </div>
            <div class="col-md-4 col-sm-6 col-xs-12">
              <div class="input-new-design">
                <label class="input-label">Data Exclusão</label>
                <q-input
                  v-model="contrato.deletedAt"
                  readonly
                  dense
                  outlined
                  class="input-field"
                />
              </div>
            </div>
          </div>
          <div class="row q-gutter-md q-mt-md">
            <div class="col-12">
              <div class="input-new-design">
                <label class="input-label"
                  >Observações
                  <span v-if="edicaoHabilitada" class="text-brand-2"
                    >(Editavel)</span
                  ></label
                >
                <q-input
                  v-model="contrato.observations"
                  :readonly="!edicaoHabilitada"
                  dense
                  outlined
                  type="textarea"
                  rows="3"
                  class="input-field"
                />
              </div>
            </div>
          </div>
          <q-btn
            color="primary"
            icon="edit"
            label="Editar"
            @click="toggleEdicao"
            v-if="!edicaoHabilitada"
            :loading="loading"
          />
          <q-btn
            flat
            label="Cancelar"
            color="negative"
            @click="cancelarEdicao"
            v-if="edicaoHabilitada"
            class="q-mr-sm"
          />
          <q-btn
            color="primary"
            label="Salvar"
            icon="save"
            @click="salvarContrato"
            v-if="edicaoHabilitada"
            :loading="salvando"
          />
        </q-card-section>
      </q-card>
    </q-expansion-item>

    <!-- Tabs com Informações Detalhadas -->
    <q-card flat bordered class="q-mt-lg">
      <q-tabs
        v-model="activeTab"
        dense
        class="text-grey"
        active-color="primary"
        indicator-color="primary"
        align="justify"
        narrow-indicator
      >
        <q-tab name="produtos" label="Produtos Vinculados" icon="inventory" />
        <q-tab name="historico" label="Histórico" icon="history" />
        <q-tab
          name="unidades"
          label="Unidades Vinculadas"
          icon="location_city"
        />
        <q-tab
          v-if="temPermissaoListar"
          name="anexos"
          label="Upload/Visualização Anexos"
          icon="attach_file"
        />
      </q-tabs>

      <q-separator />

      <q-tab-panels v-model="activeTab" animated>
        <!-- Tab Unidades -->
        <q-tab-panel name="unidades">
          <div class="row justify-between items-center q-mb-md">
            <div class="text-h6 text-weight-bold">
              Lista de Unidades Vinculadas
            </div>
            <q-btn
              color="positive"
              icon="add"
              label="Vincular Unidade"
              @click="abrirModalUnidades"
            />
          </div>
          <q-table
            :rows="unidadesVinculadas"
            :columns="unidadesColumns"
            row-key="id"
            flat
            :rows-per-page-options="[10, 25, 50]"
            class="custom-table"
          >
            <template v-slot:body-cell-actions="props">
              <q-td :props="props">
                <q-btn
                  flat
                  icon="delete"
                  color="negative"
                  size="sm"
                  @click="desvincularUnidade(props.row)"
                />
              </q-td>
            </template>
          </q-table>
        </q-tab-panel>

        <!-- Tab Produtos -->
        <q-tab-panel name="produtos">
          <div class="row justify-between items-center q-mb-md">
            <div class="text-h6 text-weight-bold">
              Lista de Produtos do Contrato
            </div>
            <q-btn
              color="positive"
              icon="add"
              label="Adicionar Produto"
              @click="abrirModalProduto()"
            />
          </div>
          <q-table
            :rows="produtos"
            :columns="produtosColumns"
            row-key="id"
            flat
            :rows-per-page-options="[10, 25, 50]"
            class="custom-table"
            :loading="loadingProdutos"
          >
            <template v-slot:body-cell-valorUnitario="props">
              <q-td :props="props">
                {{ formatarMoeda(props.value) }}
              </q-td>
            </template>
            <template v-slot:body-cell-valorTotal="props">
              <q-td :props="props">
                {{ formatarMoeda(props.value) }}
              </q-td>
            </template>
            <template v-slot:body-cell-valorVinculado="props">
              <q-td :props="props">
                {{ formatarMoeda(props.value) }}
              </q-td>
            </template>
            <template v-slot:body-cell-valorDisponivel="props">
              <q-td :props="props">
                {{ formatarMoeda(props.value) }}
              </q-td>
            </template>
            <template v-slot:body-cell-quantidadeVinculada="props">
              <q-td :props="props">
                <q-chip
                  :color="props.value > 0 ? 'positive' : 'grey'"
                  text-color="white"
                  :label="props.value || 0"
                  size="sm"
                />
              </q-td>
            </template>
            <template v-slot:body-cell-quantidadeDisponivel="props">
              <q-td :props="props">
                <q-chip
                  :color="getQuantidadeDisponivelColor(props.value)"
                  text-color="white"
                  :label="props.value || 0"
                  size="sm"
                />
              </q-td>
            </template>
            <template v-slot:body-cell-quantidade="props">
              <q-td :props="props">
                {{ formatarQuantidade(props.value) }}
              </q-td>
            </template>
            <template v-slot:body-cell-actions="props">
              <q-td :props="props">
                <q-btn
                  flat
                  icon="edit"
                  color="primary"
                  size="sm"
                  @click="abrirModalEdicaoProduto(props.row)"
                  class="q-mr-xs"
                />
                <q-btn
                  flat
                  icon="delete"
                  color="negative"
                  size="sm"
                  @click="removerProduto(props.row)"
                />
              </q-td>
            </template>
          </q-table>
        </q-tab-panel>

        <!-- Tab Histórico -->
        <q-tab-panel name="historico">
          <div class="text-h6 text-weight-bold q-mb-md">
            Histórico de Alterações do Contrato
          </div>
          <q-table
            :rows="historico"
            :columns="historicoColumns"
            row-key="id"
            flat
            :rows-per-page-options="[10, 25, 50]"
            class="custom-table"
            :loading="loadingHistorico"
          >
            <template v-slot:body-cell-acao="props">
              <q-td :props="props">
                <q-chip
                  :color="getActionColor(props.value)"
                  text-color="white"
                  dense
                  :label="formatAction(props.value)"
                />
              </q-td>
            </template>
            <template v-slot:body-cell-descricaoAcao="props">
              <q-td :props="props">
                <div class="text-caption">
                  {{ props.value }}
                </div>
              </q-td>
            </template>
            <template v-slot:body-cell-dataAlteracao="props">
              <q-td :props="props">
                {{ formatarDataHora(props.value) }}
              </q-td>
            </template>
          </q-table>
        </q-tab-panel>

        <!-- Tab Anexos -->
        <q-tab-panel name="anexos">
          <div class="row justify-between items-center q-mb-md">
            <div class="text-h6 text-weight-bold">
              Upload/Visualização de Anexos
            </div>
            <q-btn
              color="positive"
              icon="cloud_upload"
              label="Enviar Anexo"
              @click="abrirModalUpload"
              :disable="!temPermissaoUpload"
            >
              <q-tooltip v-if="!temPermissaoUpload">
                Você não tem permissão para fazer upload
              </q-tooltip>
            </q-btn>
          </div>

          <!-- Tabela de Anexos -->
          <q-table
            :rows="anexos"
            :columns="anexosColumns"
            row-key="id"
            flat
            :rows-per-page-options="[10, 25, 50]"
            class="custom-table"
            :loading="loadingAnexos"
          >
            <template v-slot:body-cell-extension="props">
              <q-td :props="props">
                <q-icon
                  :name="getFileIcon(props.value)"
                  :color="getFileIconColor(props.value)"
                  size="md"
                />
              </q-td>
            </template>

            <template v-slot:body-cell-name="props">
              <q-td :props="props">
                <div class="text-weight-medium">
                  {{ props.value }}
                </div>
              </q-td>
            </template>

            <template v-slot:body-cell-description="props">
              <q-td :props="props">
                <div
                  class="text-caption"
                  style="max-width: 200px; word-wrap: break-word"
                >
                  {{ props.value || "Sem descrição" }}
                </div>
              </q-td>
            </template>

            <template v-slot:body-cell-createdAt="props">
              <q-td :props="props">
                {{ formatarDataHora(props.value) }}
              </q-td>
            </template>

            <template v-slot:body-cell-user="props">
              <q-td :props="props">
                <div class="text-weight-medium">
                  {{ props.value.name }}
                </div>
                <div class="text-caption text-grey-6">
                  {{ props.value.sap }}
                </div>
              </q-td>
            </template>

            <template v-slot:body-cell-actions="props">
              <q-td :props="props">
                <q-btn
                  flat
                  icon="download"
                  color="primary"
                  size="sm"
                  @click="downloadAnexo(props.row)"
                  class="q-mr-xs"
                >
                  <q-tooltip>Download</q-tooltip>
                </q-btn>
                <q-btn
                  flat
                  icon="delete"
                  color="negative"
                  size="sm"
                  @click="confirmarDeleteAnexo(props.row)"
                  :disable="!temPermissaoDeletar"
                >
                  <q-tooltip>
                    {{
                      temPermissaoDeletar
                        ? "Excluir"
                        : "Você não tem permissão para excluir"
                    }}
                  </q-tooltip>
                </q-btn>
              </q-td>
            </template>

            <template v-slot:no-data="props">
              <div
                v-if="props"
                style="background-color: transparent"
                class="full-width row flex-center q-gutter-sm q-mt-sm"
              >
                <div class="text-center">
                  <q-icon name="attach_file" size="4em" color="grey-5" />
                  <div class="text-h6 q-mt-md text-grey-6">
                    {{
                      loadingAnexos
                        ? "Carregando anexos..."
                        : "Nenhum anexo encontrado"
                    }}
                  </div>
                  <div class="text-body2 text-grey-5">
                    {{
                      loadingAnexos
                        ? "Aguarde..."
                        : "Faça o upload do primeiro anexo para este contrato"
                    }}
                  </div>
                </div>
              </div>
            </template>
          </q-table>
        </q-tab-panel>
      </q-tab-panels>
    </q-card>

    <!-- Modal Gerenciar Unidades -->
    <dialog-info-design
      mensagem="Gerenciar Unidades Vinculadas"
      subMensagem="Selecione as unidades que devem estar vinculadas a este contrato:"
      :exibir="modalUnidades"
      :showConteudo="true"
      :showCancelar="true"
      width="800px"
      height="550px"
      intern_height="400px"
      @resultado="salvarVinculoUnidades"
    >
      <div class="row q-gutter-md">
        <!-- Filtro de busca de unidades -->
        <div class="col-12 q-mb-md">
          <q-input
            v-model="filtroUnidades"
            label="Buscar unidades"
            outlined
            dense
            placeholder="Digite o nome da unidade"
            clearable
          >
            <template v-slot:prepend>
              <q-icon name="search" />
            </template>
          </q-input>
        </div>

        <!-- Lista de unidades disponíveis -->
        <div class="col-12">
          <q-list bordered separator>
            <q-item-label header class="text-weight-bold">
              Unidades Disponíveis
            </q-item-label>

            <q-item
              v-for="unidade in unidadesFiltradas"
              :key="unidade.id"
              clickable
            >
              <q-item-section side>
                <q-checkbox
                  v-model="unidadesSelecionadas"
                  :val="unidade.id"
                  :label="unidade.name"
                />
              </q-item-section>
              <q-item-section>
                <q-item-label>{{ unidade.name }}</q-item-label>
                <q-item-label caption>
                  Código: {{ unidade.code || unidade.id }}
                </q-item-label>
              </q-item-section>
            </q-item>

            <q-item v-if="unidadesFiltradas.length === 0">
              <q-item-section>
                <q-item-label class="text-grey-6">
                  {{
                    carregandoUnidades
                      ? "Carregando..."
                      : "Nenhuma unidade encontrada"
                  }}
                </q-item-label>
              </q-item-section>
            </q-item>
          </q-list>
        </div>
      </div>
    </dialog-info-design>

    <!-- Modal Desvincular Unidade -->
    <dialog-info-design
      mensagem="Desvincular Unidade"
      :subMensagem="`Deseja desvincular a unidade ${unidadeParaDesvincular?.name}?`"
      :exibir="modalDesvincularUnidade"
      :showCancelar="true"
      @resultado="confirmarDesvinculoUnidade"
    />

    <!-- Modal Produto -->
    <q-dialog v-model="modalProduto" persistent>
      <q-card style="width: 1200px; max-width: 95vw; height: 730px">
        <q-card-section class="row items-center bg-brand-1 text-white">
          <div class="text-h6">Adicionar Produtos ao Contrato</div>
          <q-space />
          <q-btn icon="close" flat round dense @click="fecharModalProduto" />
        </q-card-section>

        <!-- Filtros -->
        <q-card-section>
          <div class="text-subtitle1 text-weight-bold q-mb-md">
            Filtros de Busca
          </div>
          <div class="row text-brand-5 text-weight-bold">
            <!-- Unidades -->
            <div class="col-md-3">
              Unidade:
              <q-select
                v-model="filtrosProdutos.unidade"
                :options="unidadesVinculadas"
                option-label="name"
                option-value="id"
                emit-value
                map-options
                dense
                outlined
                label="Selecione a unidade"
                clearable
                class="input-new-design"
              />
            </div>

            <!-- Produto -->
            <div class="col-md-3 q-ml-sm">
              Produto:
              <q-input
                v-model="filtrosProdutos.produto"
                dense
                outlined
                label="Nome ou código do produto"
                placeholder="Digite para buscar"
                clearable
                class="input-new-design"
              />
            </div>

            <!-- Grupo de Produto -->
            <div class="col-md-3 q-ml-sm">
              Grupo de Produto:
              <q-select
                v-model="filtrosProdutos.grupo"
                :options="gruposOptions"
                option-label="name"
                option-value="id"
                emit-value
                map-options
                dense
                outlined
                use-input
                input-debounce="500"
                @filter="filterGrupos"
                label="Selecione o grupo"
                clearable
                class="input-new-design"
              >
                <template v-slot:no-option>
                  <q-item>
                    <q-item-section class="text-grey">
                      Digite para buscar...
                    </q-item-section>
                  </q-item>
                </template>
              </q-select>
            </div>

            <!-- Categoria -->
            <div class="col-md-2 q-ml-sm">
              Categoria:
              <q-select
                v-model="filtrosProdutos.categoria"
                :options="categoriasOptions"
                option-label="name"
                option-value="id"
                emit-value
                map-options
                dense
                outlined
                use-input
                input-debounce="500"
                @filter="filterCategorias"
                label="Selecione a categoria"
                clearable
                class="input-new-design"
              >
                <template v-slot:no-option>
                  <q-item>
                    <q-item-section class="text-grey">
                      Digite para buscar...
                    </q-item-section>
                  </q-item>
                </template>
              </q-select>
            </div>
          </div>

          <div class="row q-mt-md">
            <!-- Botão Filtrar -->
            <div class="col-md-2">
              <q-btn
                @click="buscarProdutosEstoque"
                icon="filter_alt"
                no-caps
                style="
                  background-color: #7ab9e0;
                  border-radius: 8px;
                  color: white;
                "
                label="Filtrar"
                :loading="loadingBuscaProdutos"
              />
            </div>
          </div>
        </q-card-section>

        <!-- Tabela de Produtos -->
        <q-card-section class="q-pa-md" style="height: 400px">
          <div class="text-subtitle1 text-weight-bold q-mb-md">
            Produtos Disponíveis
          </div>

          <q-table
            :rows="produtosEstoque"
            :columns="produtosEstoqueColumns"
            row-key="id_produto"
            flat
            dense
            hide-pagination
            :rows-per-page-options="[10, 25, 50]"
            class="tabela-produtos-estoque"
            :loading="loadingBuscaProdutos"
            selection="multiple"
            v-model:selected="produtosSelecionados"
          >
            <!-- Template slots para formatação de dados -->
            <template v-slot:body-cell-qtd_estoque="props">
              <q-td :props="props">
                <q-chip
                  :color="getEstoqueColor(props.value)"
                  text-color="white"
                  :label="formatarQuantidade(props.value)"
                  size="sm"
                />
              </q-td>
            </template>

            <template v-slot:body-cell-preco_produto="props">
              <q-td :props="props">
                {{ formatarValorBrasileiro(props.value) }}
              </q-td>
            </template>

            <!-- Unidade de Medida -->
            <template v-slot:body-cell-descricao_unidade_de_medida="props">
              <q-td :props="props">
                <q-input
                  v-model="props.row.descricao_unidade_de_medida"
                  type="text"
                  dense
                  outlined
                  style="width: 100px"
                  :disable="!isProdutoSelecionado(props.row)"
                />
              </q-td>
            </template>

            <!-- Coluna Quantidade -->
            <template v-slot:body-cell-quantidade="props">
              <q-td :props="props">
                <q-input
                  v-model="props.row.quantidade"
                  type="number"
                  dense
                  outlined
                  min="1"
                  style="width: 100px"
                  :disable="!isProdutoSelecionado(props.row)"
                />
              </q-td>
            </template>

            <!-- Coluna Valor Unitário -->
            <template v-slot:body-cell-valorUnitario="props">
              <q-td :props="props">
                <q-input
                  v-model="props.row.valorUnitario"
                  dense
                  outlined
                  prefix="R$"
                  placeholder="0,00"
                  style="width: 140px"
                  :disable="!isProdutoSelecionado(props.row)"
                  @input="(val) => formatarValorUnitario(props.row, val)"
                  @blur="() => formatarValorUnitarioFinal(props.row)"
                />
              </q-td>
            </template>

            <!-- Template slot para produto sem dados -->
            <template v-slot:no-data="props">
              <div
                v-if="props"
                style="background-color: transparent"
                class="full-width row flex-center q-gutter-sm q-mt-sm"
              >
                <div class="text-center">
                  <q-icon name="search_off" size="4em" color="grey-5" />
                  <div class="text-h6 q-mt-md text-grey-6">
                    {{
                      loadingBuscaProdutos
                        ? "Buscando produtos..."
                        : "Nenhum produto encontrado"
                    }}
                  </div>
                  <div class="text-body2 text-grey-5">
                    {{
                      loadingBuscaProdutos
                        ? "Aguarde..."
                        : "Tente ajustar os filtros de busca"
                    }}
                  </div>
                </div>
              </div>
            </template>
          </q-table>

          <div
            v-if="produtosEstoque.length != 0"
            class="row justify-start q-mt-md"
          >
            <q-pagination
              :disable="disable"
              v-model="pagination.page"
              color="brand-5"
              active-color="secondary"
              active-text-color="white"
              :max="pagesNumber"
              :max-pages="5"
              :boundary-numbers="false"
              :direction-links="true"
              size="sm"
            />
          </div>
        </q-card-section>

        <q-card-actions align="right" class="bg-grey-1">
          <!-- Resumo dos produtos selecionados -->
          <div v-if="produtosSelecionados.length > 0" class="q-mr-md">
            <q-chip
              color="primary"
              text-color="white"
              :label="labelProdutosSelecionados"
              size="sm"
            />
          </div>

          <q-btn
            flat
            label="Cancelar"
            color="negative"
            @click="fecharModalProduto"
          />
          <q-btn
            color="positive"
            no-caps
            icon="add"
            style="background-color: #58c16d; border-radius: 8px; color: white"
            label="Adicionar Produtos Selecionados"
            @click="salvarProdutosSelecionados"
            :loading="salvandoProduto"
            :disable="produtosSelecionados.length === 0"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>

    <!-- Modal Produto Edição -->
    <q-dialog v-model="modalEdicaoProduto" persistent>
      <q-card style="min-width: 600px; max-width: 90vw">
        <q-card-section class="row items-center bg-primary text-white">
          <div class="text-h6">Editar Produto do Contrato</div>
          <q-space />
          <q-btn
            icon="close"
            flat
            round
            dense
            @click="fecharModalEdicaoProduto"
          />
        </q-card-section>

        <q-card-section>
          <div class="text-subtitle1 text-weight-bold q-mb-md">
            Informações do Produto
          </div>

          <!-- Informações não editáveis -->
          <div class="row q-gutter-md q-mb-md">
            <div class="col-md-5">
              <div class="input-new-design">
                <label class="input-label">Código do Produto</label>
                <q-input
                  v-model="produtoEdicao.codigo"
                  readonly
                  dense
                  outlined
                  class="input-field bg-grey-2"
                  disable
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="input-new-design">
                <label class="input-label">Descrição do Produto</label>
                <q-input
                  v-model="produtoEdicao.descricao"
                  readonly
                  dense
                  outlined
                  class="input-field bg-grey-2"
                  disable
                />
              </div>
            </div>
          </div>

          <div class="row q-gutter-md q-mb-md">
            <div class="col-md-5">
              <div class="input-new-design">
                <label class="input-label">Grupo</label>
                <q-input
                  v-model="produtoEdicao.grupo"
                  readonly
                  dense
                  outlined
                  class="input-field bg-grey-2"
                  disable
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="input-new-design">
                <label class="input-label">Categoria</label>
                <q-input
                  v-model="produtoEdicao.categoria"
                  readonly
                  dense
                  outlined
                  class="input-field bg-grey-2"
                  disable
                />
              </div>
            </div>
          </div>

          <q-separator class="q-my-md" />

          <div class="text-subtitle1 text-weight-bold q-mb-md text-primary">
            Campos Editáveis
          </div>

          <!-- Campos editáveis -->
          <div class="row q-gutter-md">
            <div class="col-md-3">
              <div class="input-new-design">
                <label class="input-label"
                  >Unidade de Medida <span class="text-red">*</span></label
                >
                <q-input
                  v-model="formEdicaoProduto.measurementUnit"
                  dense
                  outlined
                  class="input-field"
                  placeholder="Ex: UN, KG, M"
                  :rules="[(val) => !!val || 'Unidade de medida é obrigatória']"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="input-new-design">
                <label class="input-label"
                  >Quantidade <span class="text-red">*</span></label
                >
                <q-input
                  v-model="formEdicaoProduto.amount"
                  type="number"
                  min="1"
                  step="1"
                  dense
                  outlined
                  class="input-field"
                  placeholder="Digite a quantidade"
                  :rules="[
                    (val) => !!val || 'Quantidade é obrigatória',
                    (val) => val > 0 || 'Quantidade deve ser maior que zero',
                  ]"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="input-new-design">
                <label class="input-label"
                  >Valor Unitário <span class="text-red">*</span></label
                >
                <q-input
                  v-model="formEdicaoProduto.unitaryValue"
                  dense
                  outlined
                  class="input-field"
                  prefix="R$"
                  placeholder="0,00"
                  @input="formatarInputEdicaoUnitario"
                  @blur="formatarUnitarioFinal"
                  :rules="[
                    (val) => !!val || 'Valor unitário é obrigatório',
                    (val) =>
                      parseCurrency(val) > 0 || 'Valor deve ser maior que zero',
                  ]"
                />
              </div>
            </div>
          </div>

          <!-- Resumo calculado -->
          <div class="q-mt-md bg-grey-1 q-pa-md rounded-borders">
            <div class="text-subtitle2 text-weight-bold">Resumo</div>
            <div class="row q-gutter-md q-mt-sm">
              <div class="col">
                <div class="text-caption text-grey-6">Quantidade</div>
                <div class="text-body1 text-weight-medium">
                  {{ formEdicaoProduto.amount || 0 }}
                </div>
              </div>
              <div class="col">
                <div class="text-caption text-grey-6">Valor Unitário</div>
                <div class="text-body1 text-weight-medium">
                  {{
                    formatarMoeda(
                      parseCurrency(formEdicaoProduto.unitaryValue) || 0
                    )
                  }}
                </div>
              </div>
              <div class="col">
                <div class="text-caption text-grey-6">Valor Total</div>
                <div class="text-body1 text-weight-bold text-primary">
                  {{
                    formatarMoeda(
                      (formEdicaoProduto.amount || 0) *
                        (parseCurrency(formEdicaoProduto.unitaryValue) || 0)
                    )
                  }}
                </div>
              </div>
            </div>
          </div>
        </q-card-section>

        <q-card-actions align="right" class="bg-grey-1">
          <q-btn
            flat
            label="Cancelar"
            color="negative"
            @click="fecharModalEdicaoProduto"
          />
          <q-btn
            color="primary"
            icon="save"
            label="Salvar Alterações"
            @click="salvarEdicaoProduto"
            :loading="salvandoProduto"
            :disable="!validarFormEdicao()"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>

    <!-- Modal Upload de Anexo -->
    <q-dialog v-model="modalUploadAnexo" persistent>
      <q-card style="min-width: 600px; max-width: 90vw">
        <q-card-section class="row items-center bg-brand-1 text-white">
          <q-icon name="cloud_upload" class="q-mr-sm" />
          <div class="text-h6">Upload de Anexo</div>
          <q-space />
          <q-btn
            icon="close"
            flat
            round
            dense
            @click="modalUploadAnexo = false"
          />
        </q-card-section>

        <q-card-section>
          <div class="text-subtitle1 text-weight-bold q-mb-md">
            Informações do Arquivo
          </div>

          <!-- Container de upload estilo da aplicação -->
          <div
            class="row col-12 q-ml-lg text-brand-5 text-weight-bold q-gutter-x-sm container-input-file"
          >
            <div
              class="container q-mt-md upload-area-interactive"
              @click="triggerFileInput"
              @dragover.prevent="onDragOver"
              @dragleave.prevent="onDragLeave"
              @drop.prevent="onDrop"
            >
              <!-- Área interativa de upload -->
              <div class="upload-zone-content">
                <q-icon
                  name="cloud_upload"
                  size="48px"
                  color="brand-5"
                  class="upload-icon"
                />
                <div class="upload-text-primary">
                  Clique para selecionar o arquivo, ou arraste e solte até aqui.
                </div>
                <div class="upload-text-secondary">
                  Formatos aceitos: PDF, PNG, DOC, JPG, etc.
                </div>

                <!-- Informação do arquivo selecionado -->
                <div v-if="formUploadAnexo.arquivo" class="selected-file-info">
                  <q-icon name="description" class="q-mr-xs" />
                  <span class="selected-file-name">{{
                    formUploadAnexo.arquivo.name
                  }}</span>
                </div>
              </div>

              <input
                ref="fileInputRef"
                id="arquivo-anexo"
                type="file"
                accept="*/*"
                @change="onFileSelectedModal"
                @click="resetFileInput"
                style="display: none"
              />
            </div>
          </div>

          <!-- Nome do arquivo -->
          <div class="row q-gutter-md q-mt-md">
            <div class="col-md-6">
              <div class="input-new-design">
                <label class="input-label">
                  Nome do Arquivo <span class="text-red">*</span>
                </label>
                <q-input
                  v-model="formUploadAnexo.nomeArquivo"
                  dense
                  outlined
                  class="input-field"
                  placeholder="Digite o nome do arquivo"
                  hint="Nome que será exibido na listagem"
                />
              </div>
            </div>

            <!-- Descrição -->
            <div class="col-md-6">
              <div class="input-new-design">
                <label class="input-label"> Descrição (Opcional) </label>
                <q-input
                  v-model="formUploadAnexo.descricao"
                  dense
                  outlined
                  class="input-field"
                  placeholder="Breve descrição do arquivo"
                  hint="Informação adicional sobre o arquivo"
                />
              </div>
            </div>
          </div>

          <!-- Informações do arquivo selecionado -->
          <div
            v-if="formUploadAnexo.arquivo"
            class="q-mt-md bg-grey-1 q-pa-md rounded-borders"
          >
            <div class="text-subtitle2 text-weight-bold q-mb-sm">
              <q-icon name="info" class="q-mr-xs" />
              Informações do Arquivo
            </div>
            <div class="row q-gutter-md">
              <div class="col">
                <div class="text-caption text-grey-6">Nome Original</div>
                <div class="text-body2 text-weight-medium">
                  {{ formUploadAnexo.arquivo.name }}
                </div>
              </div>
              <div class="col">
                <div class="text-caption text-grey-6">Tamanho</div>
                <div class="text-body2 text-weight-medium">
                  {{ formatarTamanhoArquivo(formUploadAnexo.arquivo.size) }}
                </div>
              </div>
              <div class="col">
                <div class="text-caption text-grey-6">Tipo</div>
                <div class="text-body2 text-weight-medium">
                  {{ formUploadAnexo.arquivo.type || "Não identificado" }}
                </div>
              </div>
            </div>
          </div>
        </q-card-section>

        <q-card-actions align="right" class="bg-grey-1">
          <q-btn
            flat
            label="Cancelar"
            color="negative"
            @click="modalUploadAnexo = false"
          />
          <q-btn
            color="positive"
            icon="cloud_upload"
            label="Enviar Anexo"
            @click="uploadAnexo"
            :loading="loadingAnexos"
            :disable="!formUploadAnexo.arquivo || !formUploadAnexo.nomeArquivo"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import { ref, onMounted, computed, watch } from "vue";
import { useQuasar } from "quasar";
import DialogInfoDesign from "../../../components/DialogInfoDesign.vue";
import { watchDebounced } from "@vueuse/core";

export default {
  name: "DetalheContrato",
  components: {
    DialogInfoDesign,
  },

  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const quasar = useQuasar();

    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 5,
      rowsNumber: 5,
    });

    // Estados
    const loading = ref(false);
    const salvando = ref(false);
    const loadingProdutos = ref(false);
    const loadingHistorico = ref(false);
    const salvandoProduto = ref(false);
    const edicaoHabilitada = ref(false);
    const activeTab = ref("produtos");
    const time = ref(null);

    // Modais
    const modalUnidades = ref(false);
    const modalProduto = ref(false);
    const modalDesvincularUnidade = ref(false);
    const modalEdicaoProduto = ref(false);

    // Novos estados para gerenciar unidades
    const carregandoUnidades = ref(false);
    const unidadesDisponiveis = ref([]);
    const unidadesSelecionadas = ref([]);
    const filtroUnidades = ref("");
    const unidadeParaDesvincular = ref(null);

    // Dados
    const contrato = ref({});
    const contratoOriginal = ref({});
    const unidadesVinculadas = ref([]);
    const produtos = ref([]);
    const historico = ref([]);
    const produtosDisponiveis = ref([]);
    const fornecedorSelecionado = ref(null);
    const suppliesOptions = ref([]);

    // Novos dados para o modal de produtos
    const produtosEstoque = ref([]);
    const produtosSelecionados = ref([]);
    const filtrosProdutos = ref({
      unidade: null,
      produto: "",
      grupo: null,
      categoria: null,
    });
    const gruposOptions = ref([]);
    const categoriasOptions = ref([]);
    const loadingBuscaProdutos = ref(false);
    // Form de produto
    const produtoEdicao = ref(null);
    const formProduto = ref({
      produto: null,
      quantidade: 0,
      valorUnitario: 0,
    });

    // Form de edição de produto
    const formEdicaoProduto = ref({
      measurementUnit: "",
      amount: 0,
      unitaryValue: 0,
    });

    // Computed
    const vendorName = computed(
      () =>
        contrato.value.provider?.fantasyName ||
        contrato.value.provider?.businessName ||
        ""
    );
    const vendorCnpj = computed(() => contrato.value.provider?.cnpj || "");
    const userName = computed(() => contrato.value.user?.name || "");
    const userSap = computed(() => contrato.value.user?.sap || "");

    // Label dinâmico para produtos selecionados
    const labelProdutosSelecionados = computed(() => {
      const count = produtosSelecionados.value.length;
      const produto = count > 1 ? "produtos" : "produto";
      const selecionado = count > 1 ? "selecionados" : "selecionado";
      return `${count} ${produto} ${selecionado}`;
    });

    // Computed para filtrar unidades
    const unidadesFiltradas = computed(() => {
      if (!filtroUnidades.value) {
        return unidadesDisponiveis.value;
      }

      const filtro = filtroUnidades.value.toLowerCase();
      return unidadesDisponiveis.value.filter(
        (unidade) =>
          unidade.name.toLowerCase().includes(filtro) ||
          (unidade.code && unidade.code.toString().includes(filtro))
      );
    });

    // Colunas das tabelas
    const unidadesColumns = [
      {
        name: "code",
        label: "Código",
        align: "left",
        field: "code",
        sortable: true,
      },
      {
        name: "name",
        label: "Nome da Unidade",
        align: "left",
        field: "name",
        sortable: true,
      },
      {
        name: "address",
        label: "Endereço",
        align: "left",
        field: "address",
        sortable: true,
      },
      {
        name: "actions",
        label: "Ações",
        align: "center",
        field: "actions",
      },
    ];

    const produtosColumns = [
      {
        name: "codigo",
        label: "Código Produto",
        align: "left",
        field: "codigo",
        sortable: true,
      },
      {
        name: "descricao",
        label: "Descrição Produto",
        align: "left",
        field: "descricao",
        sortable: true,
      },
      {
        name: "unidadeMedida",
        label: "Unidade Medida",
        align: "center",
        field: "unidadeMedida",
        sortable: true,
      },
      {
        name: "grupo",
        label: "Grupo",
        align: "left",
        field: "grupo",
        sortable: true,
      },
      {
        name: "categoria",
        label: "Categoria",
        align: "left",
        field: "categoria",
        sortable: true,
      },
      {
        name: "valorUnitario",
        label: "Valor Unitário",
        align: "right",
        field: "valorUnitario",
        sortable: true,
      },
      {
        name: "quantidade",
        label: "Quantidade Contrato",
        align: "center",
        field: "quantidade",
        sortable: true,
      },
      {
        name: "quantidadeVinculada",
        label: "Qtd. Vinculada",
        align: "center",
        field: "quantidadeVinculada",
        sortable: true,
      },
      {
        name: "quantidadeDisponivel",
        label: "Qtd. Disponível",
        align: "center",
        field: "quantidadeDisponivel",
        sortable: true,
      },
      {
        name: "valorTotal",
        label: "Valor Total Contrato",
        align: "right",
        field: "valorTotal",
        sortable: true,
      },
      {
        name: "valorVinculado",
        label: "Valor Vinculado",
        align: "right",
        field: "valorVinculado",
        sortable: true,
      },
      {
        name: "valorDisponivel",
        label: "Valor Disponível",
        align: "right",
        field: "valorDisponivel",
        sortable: true,
      },
      {
        name: "actions",
        label: "Ações",
        align: "center",
        field: "actions",
      },
    ];

    const historicoColumns = [
      {
        name: "id",
        label: "ID",
        align: "left",
        field: "id",
        sortable: true,
      },
      {
        name: "versaoContrato",
        label: "Versão Contrato",
        align: "center",
        field: "versaoContrato",
        sortable: true,
      },
      {
        name: "nomeUsuario",
        label: "Nome Usuário",
        align: "left",
        field: "nomeUsuario",
        sortable: true,
      },
      {
        name: "matriculaUsuario",
        label: "SAP Usuário",
        align: "left",
        field: "matriculaUsuario",
        sortable: true,
      },
      {
        name: "acao",
        label: "Ação",
        align: "left",
        field: "acao",
        sortable: true,
      },
      {
        name: "descricaoAcao",
        label: "Descrição",
        align: "left",
        field: "descricaoAcao",
        sortable: true,
      },
      {
        name: "dataAlteracao",
        label: "Data Alteração",
        align: "center",
        field: "dataAlteracao",
        sortable: true,
      },
    ];

    const produtosEstoqueColumns = [
      {
        name: "codigo_produto",
        label: "Código Produto",
        align: "left",
        field: "codigo_produto",
        sortable: true,
      },
      {
        name: "nome_produto",
        label: "Nome Produto",
        align: "left",
        field: "nome_produto",
        sortable: true,
        style:
          "max-width: 200px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;",
      },
      {
        name: "nome_grupo",
        label: "Grupo",
        align: "left",
        field: "nome_grupo",
        sortable: true,
      },
      {
        name: "categoria_descricao",
        label: "Categoria",
        align: "left",
        field: "categoria_descricao",
        sortable: true,
      },
      {
        name: "descricao_unidade_de_medida",
        label: "Un. Medida",
        align: "center",
        field: "descricao_unidade_de_medida",
        sortable: true,
      },
      {
        name: "qtd_estoque",
        label: "Estoque Atual",
        align: "center",
        field: "qtd_estoque",
        sortable: true,
      },
      {
        name: "preco_produto",
        label: "Preço Produto",
        align: "right",
        field: "preco_produto",
        sortable: true,
      },
      {
        name: "quantidade",
        label: "Quantidade",
        align: "center",
        field: "quantidade",
        required: true,
      },
      {
        name: "valorUnitario",
        label: "Valor Unitário",
        align: "right",
        field: "valorUnitario",
        required: true,
      },
    ];

    const anexosColumns = [
      {
        name: "contractId",
        label: "ID Anexo",
        align: "left",
        field: "contractId",
        sortable: true,
      },
      {
        name: "extension",
        label: "Extensão",
        align: "left",
        field: "extension",
        sortable: true,
      },
      {
        name: "name",
        label: "Nome do Arquivo",
        align: "left",
        field: "name",
        sortable: true,
      },
      {
        name: "description",
        label: "Descrição",
        align: "left",
        field: "description",
        sortable: true,
      },
      {
        name: "createdAt",
        label: "Data de Upload",
        align: "center",
        field: "createdAt",
        sortable: true,
      },
      {
        name: "user",
        label: "Usuário",
        align: "left",
        field: "user",
        sortable: true,
      },
      {
        name: "actions",
        label: "Ações",
        align: "center",
        field: "actions",
      },
    ];

    // Métodos
    const carregarContrato = async () => {
      try {
        loading.value = true;
        const contratoId = route.params.id;

        const response = await store.dispatch(
          "gdcStore/getContratoDetalhe",
          contratoId
        );

        // Adaptar os dados da resposta para o formato esperado pelo componente
        const contratoData = response.data.result;
        contrato.value = {
          ...contratoData,
          // Mapear campos conforme necessário
          startDate: contratoData.startDate
            ? contratoData.startDate.split(" ")[0]
            : "",
          endDate: contratoData.endDate
            ? contratoData.endDate.split(" ")[0]
            : "",
          // Formatar valor total no padrão brasileiro
          totalValue: contratoData.totalValue
            ? parseFloat(contratoData.totalValue).toLocaleString("pt-BR", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })
            : "0,00",
          createdAt: contratoData.createdAt
            ? new Date(contratoData.createdAt).toLocaleDateString("pt-BR")
            : "",
          updatedAt: contratoData.updatedAt
            ? new Date(contratoData.updatedAt).toLocaleDateString("pt-BR")
            : "",
          deletedAt: contratoData.deletedAt
            ? new Date(contratoData.deletedAt).toLocaleDateString("pt-BR")
            : "",
        };

        contratoOriginal.value = { ...contrato.value };

        // Inicializar fornecedor selecionado para edição
        if (contratoData.provider) {
          fornecedorSelecionado.value = {
            id: contratoData.provider.id,
            fantasyName: contratoData.provider.fantasyName,
            businessName: contratoData.provider.businessName,
            cnpj: contratoData.provider.cnpj,
            nome: contratoData.provider.fantasyName,
          };
        }

        // Carregar unidades vinculadas se existirem
        if (contratoData.vendors && contratoData.vendors.length > 0) {
          unidadesVinculadas.value = contratoData.vendors.map((v) => ({
            id: v.vendor.id,
            code: v.vendor.id,
            name: v.vendor.name,
            address: "Não informado",
          }));
        }
      } catch (error) {
        console.error("Erro ao carregar contrato:", error);
        quasar.notify({
          type: "negative",
          message: "Erro ao carregar dados do contrato",
          position: "bottom",
          timeout: 3000,
        });
      } finally {
        loading.value = false;
      }
    };

    const carregarProdutos = async () => {
      try {
        loadingProdutos.value = true;
        const contratoId = route.params.id;

        const response = await store.dispatch(
          "gdcStore/getContratoProdutos",
          contratoId
        );

        // Adaptar os dados da resposta para o formato esperado pelo componente
        let produtosData = [];

        if (response.data.result) {
          // Se a resposta tem estrutura com result
          if (Array.isArray(response.data.result)) {
            produtosData = response.data.result;
          } else if (
            response.data.result.data &&
            Array.isArray(response.data.result.data)
          ) {
            produtosData = response.data.result.data;
          } else if (response.data.result) {
            produtosData = [response.data.result];
          }
        } else if (Array.isArray(response.data)) {
          // Se a resposta é diretamente um array
          produtosData = response.data;
        }

        // Mapear dados dos produtos para o formato esperado pela tabela
        produtos.value = produtosData.map((produto) => {
          const extrairGrupo = (prod) => {
            const caminhos = [
              prod.product?.productGroup?.description,
              prod.product?.productGroup?.name,
              prod.product?.group?.description,
              prod.product?.group?.name,
              prod.productGroup?.description,
              prod.productGroup?.name,
              prod.productGroup,
              prod.grupo?.description,
              prod.grupo?.name,
              prod.grupo,
              prod.groupDescription,
              prod.groupName,
              prod.group_description,
              prod.group_name,
              prod.nome_grupo,
              prod.descricao_grupo,
            ];

            for (const caminho of caminhos) {
              if (
                caminho &&
                caminho !== "N/A" &&
                caminho !== "-" &&
                caminho.trim() !== ""
              ) {
                return caminho;
              }
            }

            return "Não informado";
          };

          const extrairCategoria = (prod) => {
            const caminhos = [
              prod.product?.productCategory?.description,
              prod.product?.productCategory?.name,
              prod.product?.category?.description,
              prod.product?.category?.name,
              prod.productCategory?.description,
              prod.productCategory?.name,
              prod.productCategory,
              prod.categoria?.description,
              prod.categoria?.name,
              prod.categoria,
              prod.categoryDescription,
              prod.categoryName,
              prod.category_description,
              prod.category_name,
              prod.categoria_descricao,
              prod.descricao_categoria,
            ];

            for (const caminho of caminhos) {
              if (
                caminho &&
                caminho !== "N/A" &&
                caminho !== "-" &&
                caminho.trim() !== ""
              ) {
                return caminho;
              }
            }

            return "Não informado";
          };

          return {
            id: produto.id || produto.contractProductId || Math.random(),
            codigo:
              produto.product?.code ||
              produto.productCode ||
              produto.codigo ||
              "N/A",
            descricao:
              produto.product?.description ||
              produto.product?.name ||
              produto.productDescription ||
              produto.descricao ||
              produto.name ||
              "N/A",
            unidadeMedida:
              produto.measurementUnit ||
              produto.unitMeasure ||
              produto.unidadeMedida ||
              "UN",
            grupo: extrairGrupo(produto),
            categoria: extrairCategoria(produto),
            quantidade:
              produto.amount || produto.quantity || produto.quantidade || 0,
            valorUnitario:
              produto.unitaryValue ||
              produto.unitPrice ||
              produto.valorUnitario ||
              0,
            valorTotal:
              produto.totalValue ||
              (produto.amount || produto.quantity || produto.quantidade || 0) *
                (produto.unitaryValue ||
                  produto.unitPrice ||
                  produto.valorUnitario ||
                  0),
            // Novos campos de quantidades e valores vinculados/disponíveis
            quantidadeVinculada: produto.linkedQuantity || 0,
            quantidadeDisponivel: produto.availableQuantity || 0,
            valorVinculado: produto.linkedValue || 0,
            valorDisponivel: produto.availableValue || 0,
            // Campos adicionais que podem estar na resposta
            contractProductId: produto.contractProductId || produto.id,
            productId: produto.productId || produto.product?.id,
            createdAt: produto.createdAt,
            updatedAt: produto.updatedAt,
          };
        });
      } catch (error) {
        console.error("Erro ao carregar produtos:", error);
        quasar.notify({
          type: "negative",
          message: "Erro ao carregar produtos do contrato",
          position: "bottom",
          timeout: 3000,
        });
      } finally {
        loadingProdutos.value = false;
      }
    };

    const carregarHistorico = async () => {
      try {
        loadingHistorico.value = true;
        const contratoId = route.params.id;

        const response = await store.dispatch(
          "gdcStore/getContratoHistorico",
          contratoId
        );

        const historicoData = response.data.result.data;
        historico.value = historicoData.map((item) => ({
          id: item.id,
          versaoContrato: item.contractVersionId,
          nomeUsuario: item.user.name,
          matriculaUsuario: item.user.sap,
          acao: item.action,
          descricaoAcao: item.description || "Sem descrição",
          dataAlteracao: item.createdAt,
          aditiveContract: item.aditiveContract,
          contractProductId: item.contractProductId,
          productCode: item.productCode,
          productDescription: item.productDescription,
        }));
      } catch (error) {
        console.error("Erro ao carregar histórico:", error);
        quasar.notify({
          type: "negative",
          message: "Erro ao carregar histórico do contrato",
          position: "bottom",
          timeout: 3000,
        });
      } finally {
        loadingHistorico.value = false;
      }
    };

    const toggleEdicao = () => {
      edicaoHabilitada.value = !edicaoHabilitada.value;
      if (!edicaoHabilitada.value) {
        contrato.value = { ...contratoOriginal.value };
      }
    };

    const cancelarEdicao = () => {
      contrato.value = { ...contratoOriginal.value };
      edicaoHabilitada.value = false;
    };

    const validarFormulario = () => {
      if (!contrato.value.contractNumber?.trim()) {
        quasar.notify({
          type: "negative",
          message: "Número do contrato é obrigatório",
          position: "bottom",
          timeout: 3000,
        });
        return false;
      }

      if (!contrato.value.supplyName?.trim()) {
        quasar.notify({
          type: "negative",
          message: "Tipo de suprimento é obrigatório",
          position: "bottom",
          timeout: 3000,
        });
        return false;
      }

      if (!contrato.value.startDate) {
        quasar.notify({
          type: "negative",
          message: "Data de início é obrigatória",
          position: "bottom",
          timeout: 3000,
        });
        return false;
      }

      if (!contrato.value.endDate) {
        quasar.notify({
          type: "negative",
          message: "Data de término é obrigatória",
          position: "bottom",
          timeout: 3000,
        });
        return false;
      }

      if (
        new Date(contrato.value.startDate) >= new Date(contrato.value.endDate)
      ) {
        quasar.notify({
          type: "negative",
          message: "Data de término deve ser posterior à data de início",
          position: "bottom",
          timeout: 3000,
        });
        return false;
      }

      if (
        !contrato.value.totalValue ||
        parseFloat(contrato.value.totalValue) <= 0
      ) {
        quasar.notify({
          type: "negative",
          message: "Valor total deve ser maior que zero",
          position: "bottom",
          timeout: 3000,
        });
        return false;
      }

      return true;
    };

    const salvarContrato = async () => {
      try {
        // Validar formulário antes de salvar
        if (!validarFormulario()) {
          return;
        }

        salvando.value = true;
        const contratoId = route.params.id;

        let currencyFormatted = parseCurrency(contrato.value.totalValue);
        // Preparar os dados no formato esperado pela API
        const contractData = {
          contractNumber: contrato.value.contractNumber,
          startDate: contrato.value.startDate,
          endDate: contrato.value.endDate,
          totalValue: currencyFormatted || 0,
          // supplyName: contrato.value.supplyName,
          aditiveNumber: parseInt(contrato.value.aditiveNumber) || 0,
          observations: contrato.value.observations,
        };

        // Verificar se houve mudanças nos dados do contrato
        const verificarMudancas = () => {
          const campos = [
            "contractNumber",
            "startDate",
            "endDate",
            "totalValue",
            "supplyName",
            "aditiveNumber",
            "observations",
          ];

          return campos.some((campo) => {
            const valorAtual =
              campo === "totalValue"
                ? contrato.value[campo] || 0
                : campo === "aditiveNumber"
                ? parseInt(contrato.value[campo]) || 0
                : contrato.value[campo];

            const valorOriginal =
              campo === "totalValue"
                ? contratoOriginal.value[campo] || 0
                : campo === "aditiveNumber"
                ? parseInt(contratoOriginal.value[campo]) || 0
                : contratoOriginal.value[campo];

            return valorAtual !== valorOriginal;
          });
        };

        const houveMudancas = verificarMudancas();

        if (!houveMudancas) {
          edicaoHabilitada.value = false;
          quasar.notify({
            type: "info",
            message: "Nenhuma alteração foi detectada no contrato",
            position: "bottom",
            timeout: 3000,
          });
          return;
        }

        await store.dispatch("gdcStore/atualizarContrato", {
          contratoId,
          contratoData: contractData,
        });

        // Recarregar os dados do contrato após a atualização
        await carregarContrato();
        edicaoHabilitada.value = false;

        quasar.notify({
          type: "positive",
          message: "Contrato atualizado com sucesso!",
          position: "bottom",
          timeout: 3000,
        });
      } catch (error) {
        console.error("Erro ao salvar contrato:", error);
        quasar.notify({
          type: "negative",
          message: "Erro ao salvar contrato",
          position: "bottom",
          timeout: 3000,
        });
      } finally {
        salvando.value = false;
      }
    };

    const abrirModalUnidades = async () => {
      await carregarUnidadesDisponiveis();
      // Inicializar com as unidades já vinculadas
      unidadesSelecionadas.value = unidadesVinculadas.value.map((u) => u.id);
      modalUnidades.value = true;
    };

    const carregarUnidadesDisponiveis = async () => {
      try {
        carregandoUnidades.value = true;
        // Buscar todas as unidades disponíveis do sistema
        const response = await store.dispatch("org/listarUnidades");

        if (response && response.listaUnidades) {
          unidadesDisponiveis.value = response.listaUnidades.map((unidade) => ({
            id: unidade.id,
            name: unidade.nome,
            code: unidade.codigoIntegracaoUnidade || unidade.id,
          }));
        }
      } catch (error) {
        console.error("Erro ao carregar unidades:", error);
        quasar.notify({
          type: "negative",
          message: "Erro ao carregar unidades disponíveis",
          position: "bottom",
          timeout: 3000,
        });
      } finally {
        carregandoUnidades.value = false;
      }
    };

    const salvarVinculoUnidades = async (confirmar) => {
      modalUnidades.value = false;

      if (!confirmar) {
        // Cancelar - resetar seleções
        unidadesSelecionadas.value = [];
        return;
      }

      try {
        const contratoId = route.params.id;
        const unidadesAtualmenteVinculadas = unidadesVinculadas.value.map(
          (u) => u.id
        );
        const unidadesParaVincular = unidadesSelecionadas.value.filter(
          (id) => !unidadesAtualmenteVinculadas.includes(id)
        );
        const unidadesParaDesvincular = unidadesAtualmenteVinculadas.filter(
          (id) => !unidadesSelecionadas.value.includes(id)
        );

        // Vincular novas unidades
        if (unidadesParaVincular.length > 0) {
          await store.dispatch("gdcStore/vincularVendorContrato", {
            contratoId,
            vendorsIds: unidadesParaVincular,
          });
        }

        // Desvincular unidades removidas
        if (unidadesParaDesvincular.length > 0) {
          await store.dispatch("gdcStore/desvincularVendorContrato", {
            contratoId,
            vendorsIds: unidadesParaDesvincular,
          });
        }

        // Recarregar dados do contrato
        await carregarContrato();

        quasar.notify({
          type: "positive",
          message: "Unidades vinculadas atualizadas com sucesso!",
          position: "bottom",
          timeout: 3000,
        });
      } catch (error) {
        console.error("Erro ao atualizar vínculos:", error);
        quasar.notify({
          type: "negative",
          message: "Erro ao atualizar vínculos das unidades",
          position: "bottom",
          timeout: 3000,
        });
      }
    };

    const desvincularUnidade = (unidade) => {
      unidadeParaDesvincular.value = unidade;
      modalDesvincularUnidade.value = true;
    };

    const confirmarDesvinculoUnidade = async (resultado) => {
      if (resultado) {
        try {
          const contratoId = route.params.id;
          await store.dispatch("gdcStore/desvincularVendorContrato", {
            contratoId,
            vendorsIds: [unidadeParaDesvincular.value.id],
          });

          // Recarregar dados do contrato
          await carregarContrato();

          quasar.notify({
            type: "positive",
            message: `Unidade ${unidadeParaDesvincular.value.name} desvinculada com sucesso!`,
            position: "bottom",
            timeout: 3000,
          });
        } catch (error) {
          console.error("Erro ao desvincular unidade:", error);
          quasar.notify({
            type: "negative",
            message: "Erro ao desvincular unidade",
            position: "bottom",
            timeout: 3000,
          });
        }
      }
      modalDesvincularUnidade.value = false;
      unidadeParaDesvincular.value = null;
    };

    const abrirModalProduto = (produto = null) => {
      produtoEdicao.value = produto;

      if (produto) {
        // Modo edição
        formProduto.value = {
          produto: produto,
          quantidade: produto.quantidade,
          valorUnitario: produto.valorUnitario,
        };
      } else {
        // Modo adição - limpar dados
        formProduto.value = {
          produto: null,
          quantidade: 0,
          valorUnitario: 0,
        };
        produtosEstoque.value = [];
        produtosSelecionados.value = [];
        filtrosProdutos.value = {
          unidade:
            unidadesVinculadas.value.length > 0
              ? unidadesVinculadas.value[0].id
              : null,
          produto: "",
          grupo: null,
          categoria: null,
        };
      }
      buscarProdutosEstoque();
      modalProduto.value = true;
    };

    const fecharModalProduto = () => {
      modalProduto.value = false;
      produtoEdicao.value = null;
      formProduto.value = {
        produto: null,
        quantidade: 0,
        valorUnitario: 0,
      };
      // Limpar dados do modal
      produtosEstoque.value = [];
      produtosSelecionados.value = [];
      filtrosProdutos.value = {
        unidade: null,
        produto: "",
        grupo: null,
        categoria: null,
      };
    };

    // Buscar produtos no estoque
    const buscarProdutosEstoque = async (pageParam, rowsPerPageParam) => {
      try {
        loadingBuscaProdutos.value = true;

        const page =
          typeof pageParam === "object" && pageParam !== null
            ? pagination.value.page
            : pageParam || pagination.value.page;
        const rowsPerPage = rowsPerPageParam || pagination.value.rowsPerPage;

        const params = {
          vendor_id: filtrosProdutos.value.unidade,
          product: filtrosProdutos.value.produto || "",
          product_group_id: filtrosProdutos.value.grupo || "",
          product_category_id: filtrosProdutos.value.categoria || "",
          per_page: rowsPerPage,
          page: page,
        };

        // Remover parâmetros vazios
        Object.keys(params).forEach((key) => {
          if (!params[key] && params[key] !== 0) {
            delete params[key];
          }
        });

        const response = await store.dispatch(
          "gdcStore/getStockReport",
          params
        );

        // Mapear dados da resposta para o formato da tabela
        const dadosEstoque = response.data.results.data;

        produtosEstoque.value = dadosEstoque.map((item) => ({
          id: item.id_produto || `${item.codigo_produto}_${Date.now()}`,
          id_produto: item.id_produto,
          codigo_produto: item.codigo_produto || "",
          nome_produto: item.nome_produto || "",
          descricao_do_produto: item.descricao_do_produto || "",
          nome_grupo: item.nome_grupo || "-",
          categoria_descricao: item.categoria_descricao || "-",
          descricao_unidade_de_medida: item.descricao_unidade_de_medida || "-",
          qtd_estoque: item.qtd_estoque || "0",
          preco_produto: item.preco_produto || "0,00",
          quantidade: 1,
          valorUnitario: "",
          // Campos para preenchimento quando não existem
          grupoSelecionado: null,
          categoriaSelecionada: null,
          unidadeMedidaInput: "",
          // Dados originais para envio
          product_group_id: item.product_group_id,
          categoria_codigo: item.categoria_codigo,
          vendor_id: item.vendor_id,
          unidade_de_medida: item.unidade_de_medida,
        }));

        pagination.value.page = response.data.results.current_page;
        pagination.value.rowsPerPage = response.data.results.per_page;
        pagination.value.rowsNumber = response.data.results.total;
      } catch (error) {
        console.error(error);
        quasar.notify({
          type: "negative",
          message: "Erro ao buscar produtos no estoque",
          position: "bottom",
          timeout: 3000,
        });
      } finally {
        loadingBuscaProdutos.value = false;
      }
    };

    // Verificar se produto está selecionado
    const isProdutoSelecionado = (produto) => {
      return produtosSelecionados.value.some((p) => p.id === produto.id);
    };

    // Formatar valor unitário
    const formatarValorUnitario = (produto, val) => {
      if (val) {
        // Remover caracteres não numéricos exceto vírgula e ponto
        let valor = val.toString().replace(/[^\d.,]/g, "");
        // Converter vírgula para ponto
        valor = valor.replace(",", ".");
        produto.valorUnitario = valor;
      }
    };

    // Formatar valor final com separadores de milhares
    const formatarValorUnitarioFinal = (produto) => {
      if (!produto.valorUnitario) {
        produto.valorUnitario = "0,00";
        return;
      }

      let valor = produto.valorUnitario.toString();

      // Remove formatação existente
      valor = valor.replace(/\./g, "").replace(",", ".");

      // Converte para número
      const numero = parseFloat(valor) || 0;

      // Formata com separadores brasileiros
      produto.valorUnitario = numero.toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    };

    // Formatar valores brasileiros (com vírgula)
    const formatarValorBrasileiro = (valor) => {
      if (!valor || valor === "0,00" || valor === "0") return "R$ 0,00";

      // Se já estiver formatado, retornar como está
      if (typeof valor === "string" && valor.includes(",")) {
        const numero = parseFloat(valor.replace(",", "."));
        return new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
        }).format(numero || 0);
      }

      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(parseFloat(valor) || 0);
    };

    // Formatar input durante a digitação (remove caracteres não numéricos)
    const formatarInput = (event) => {
      let valor = event.target.value || "";

      // Remove tudo que não é dígito, vírgula ou ponto
      valor = valor.replace(/[^\d,.-]/g, "");

      // Permite apenas uma vírgula ou ponto decimal
      const partes = valor.split(/[,.]/);
      if (partes.length > 2) {
        valor = partes[0] + "," + partes[1];
      }

      // Limita casas decimais a 2
      if (partes[1] && partes[1].length > 2) {
        valor = partes[0] + "," + partes[1].substring(0, 2);
      }

      contrato.value.totalValue = valor;
    };

    // Formatar valor final com separadores de milhares
    const formatarValorFinal = () => {
      if (!contrato.value.totalValue) {
        contrato.value.totalValue = "0,00";
        return;
      }

      let valor = contrato.value.totalValue.toString();

      // Remove formatação existente
      valor = valor.replace(/\./g, "").replace(",", ".");

      // Converte para número
      const numero = parseFloat(valor) || 0;

      // Formata com separadores brasileiros
      contrato.value.totalValue = numero.toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    };

    const formatarInputEdicaoUnitario = (val) => {
      let valor = (val || "").toString();

      valor = valor.replace(/[^\d,.-]/g, "");

      const partes = valor.split(/[,.]/);
      if (partes.length > 2) {
        valor = partes[0] + "," + partes[1];
      }

      if (partes[1] && partes[1].length > 2) {
        valor = partes[0] + "," + partes[1].substring(0, 2);
      }

      formEdicaoProduto.value.unitaryValue = valor;
    };

    const formatarUnitarioFinal = () => {
      if (!formEdicaoProduto.value.unitaryValue) {
        formEdicaoProduto.value.unitaryValue = "0,00";
        return;
      }

      let valor = formEdicaoProduto.value.unitaryValue.toString();

      valor = valor.replace(/\./g, "").replace(",", ".");

      const numero = parseFloat(valor) || 0;

      formEdicaoProduto.value.unitaryValue = numero.toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    };

    // Função para converter valor formatado para número (para salvar no backend)
    const parseCurrency = (valorFormatado) => {
      if (!valorFormatado) return 0;

      // Remove pontos (separadores de milhares) e substitui vírgula por ponto
      const numero = valorFormatado.replace(/\./g, "").replace(",", ".");

      return parseFloat(numero) || 0;
    };

    // Formatar quantidade
    const formatarQuantidade = (quantidade) => {
      if (quantidade === null || quantidade === undefined || quantidade === "")
        return "0";

      // converte string com virgula para numero
      const num =
        typeof quantidade === "string"
          ? parseFloat(quantidade.replace(",", "."))
          : parseFloat(quantidade);

      if (isNaN(num)) return "0";

      // determina casas decimais necessarias (preserva todas, ate 4)
      const str = num.toString();
      const decimalPart = str.includes(".") ? str.split(".")[1] : "";
      const decimalPlaces = Math.min(decimalPart.length, 4);

      return num.toLocaleString("pt-BR", {
        minimumFractionDigits: decimalPlaces,
        maximumFractionDigits: 4,
      });
    };

    // Cor do estoque baseado na quantidade
    const getEstoqueColor = (quantidade) => {
      const qtd = parseFloat(quantidade) || 0;
      if (qtd <= 0) return "negative";
      if (qtd <= 10) return "warning";
      return "positive";
    };

    const getQuantidadeDisponivelColor = (quantidade) => {
      if (quantidade < 0) return "negative";
      if (quantidade === 0) return "warning";
      return "positive";
    };

    const getValorDisponivelColor = (valor) => {
      const valorNum = parseFloat(valor) || 0;
      if (valorNum < 0) return "negative";
      if (valorNum === 0) return "warning";
      return "positive";
    };

    // Limpar filtros
    const limparFiltros = () => {
      filtrosProdutos.value = {
        unidade:
          unidadesVinculadas.value.length > 0
            ? unidadesVinculadas.value[0].id
            : null,
        produto: "",
        grupo: null,
        categoria: null,
      };
      produtosEstoque.value = [];
      produtosSelecionados.value = [];
    };

    // Filtros para grupos e categorias
    const filterGrupos = (val, update, abort) => {
      if (val === "") {
        update(() => {
          gruposOptions.value = [];
        });
        return;
      }

      store
        .dispatch("compras/getGrupos", {
          vendor_id: store.state.org.unidadeData.id,
          search: val,
          page: 1,
        })
        .then((response) => {
          let dados = [];

          if (response.data?.results?.data) {
            dados = response.data.results.data;
          } else if (response.data?.data) {
            dados = response.data.data;
          } else if (Array.isArray(response.data?.results)) {
            dados = response.data.results;
          } else if (Array.isArray(response.data)) {
            dados = response.data;
          }

          update(() => {
            gruposOptions.value = dados || [];
          });
        })
        .catch((error) => {
          console.error(error);
          abort();
        });
    };

    const filterCategorias = (val, update, abort) => {
      if (val === "" || val.length < 2) {
        update(() => {
          categoriasOptions.value = [];
        });
        return;
      }

      store
        .dispatch("gdcStore/getCategory", {
          search: val,
          page: 1,
          per_page: 20,
        })
        .then((response) => {
          let dados = [];

          if (response.data?.results?.data) {
            dados = response.data.results.data;
          } else if (response.data?.data) {
            dados = response.data.data;
          } else if (Array.isArray(response.data?.results)) {
            dados = response.data.results;
          } else if (Array.isArray(response.data)) {
            dados = response.data;
          }

          const dadosFormatados = dados.map((cat) => ({
            id: cat.id || cat.code || cat.codigo,
            name:
              cat.name ||
              cat.description ||
              cat.descricao ||
              cat.categoria_descricao,
            ...cat,
          }));

          update(() => {
            categoriasOptions.value = dadosFormatados;
          });
        })
        .catch((error) => {
          console.error("❌ Erro ao carregar categorias:", error);
          console.error("❌ Error response:", error.response);
          abort();
        });
    };

    const salvarProduto = async () => {
      try {
        salvandoProduto.value = true;
        const contratoId = route.params.id;

        if (produtoEdicao.value) {
          // Editar produto existente - manter lógica original
          await store.dispatch("gdcStore/editarProdutoContrato", {
            contratoId,
            produtoId: produtoEdicao.value.id,
            produtoData: {
              quantidade: formProduto.value.quantidade,
              valorUnitario: formProduto.value.valorUnitario,
            },
          });

          quasar.notify({
            type: "positive",
            message: "Produto atualizado com sucesso!",
            position: "bottom",
            timeout: 3000,
          });
        }

        fecharModalProduto();
        await carregarProdutos();
      } catch (error) {
        console.error("Erro ao salvar produto:", error);
        quasar.notify({
          type: "negative",
          message: "Erro ao salvar produto",
          position: "bottom",
          timeout: 3000,
        });
      } finally {
        salvandoProduto.value = false;
      }
    };

    const salvarProdutosSelecionados = async () => {
      try {
        salvandoProduto.value = true;
        const contratoId = route.params.id;

        // Validar produtos selecionados
        const produtosValidos = [];
        for (const produto of produtosSelecionados.value) {
          // Validações obrigatórias
          if (!produto.quantidade || produto.quantidade <= 0) {
            quasar.notify({
              type: "negative",
              message: `Quantidade é obrigatória para o produto ${produto.nome_produto}`,
              position: "bottom",
              timeout: 3000,
            });
            return;
          }

          if (!produto.valorUnitario || produto.valorUnitario <= 0) {
            quasar.notify({
              type: "negative",
              message: `Valor unitário é obrigatório para o produto ${produto.nome_produto}`,
              position: "bottom",
              timeout: 3000,
            });
            return;
          }

          // Usar os dados já existentes da API ou permitir campos obrigatórios vazios
          const grupoId = produto.product_group_id || produto.grupoSelecionado;
          const categoriaId = undefined;
          const unidadeMedida =
            produto.unidade_de_medida ||
            produto.descricao_unidade_de_medida ||
            produto.unidadeMedidaInput;

          // Se não tiver grupo na API e não foi selecionado, será obrigatório selecionar
          if (!grupoId && !produto.nome_grupo) {
            quasar.notify({
              type: "negative",
              message: `Grupo é obrigatório para o produto ${produto.nome_produto}`,
              position: "bottom",
              timeout: 3000,
            });
            return;
          }

          // Se não tiver categoria na API e não foi selecionada, será obrigatório selecionar
          if (!categoriaId && !produto.categoria_descricao) {
            quasar.notify({
              type: "negative",
              message: `Categoria é obrigatória para o produto ${produto.nome_produto}`,
              position: "bottom",
              timeout: 3000,
            });
            return;
          }

          // Se não tiver unidade de medida na API e não foi preenchida, será obrigatório preencher
          if (!unidadeMedida && !produto.descricao_unidade_de_medida) {
            quasar.notify({
              type: "negative",
              message: `Unidade de medida é obrigatória para o produto ${produto.nome_produto}`,
              position: "bottom",
              timeout: 3000,
            });
            return;
          }

          // Preparar dados para envio usando os IDs corretos da API
          produtosValidos.push({
            productId: produto.id_produto,
            productGroupId: grupoId == null ? undefined : grupoId,
            productCategoryId: categoriaId == null ? undefined : categoriaId,
            measurementUnit: unidadeMedida == null ? undefined : unidadeMedida,
            amount: produto.quantidade == null ? undefined : produto.quantidade,
            unitaryValue:
              produto.valorUnitario == null
                ? undefined
                : parseCurrency(produto.valorUnitario),
          });
        }

        // Enviar produtos para a API
        const promises = produtosValidos.map((produtoData) =>
          store.dispatch("gdcStore/adicionarProdutoContrato", {
            contratoId,
            produtoData,
          })
        );

        await Promise.all(promises);

        fecharModalProduto();
        await carregarProdutos();

        quasar.notify({
          type: "positive",
          message: `${produtosValidos.length} produtos adicionados com sucesso!`,
          position: "bottom",
          timeout: 3000,
        });
      } catch (error) {
        console.error("Erro ao salvar produtos:", error);
        quasar.notify({
          type: "negative",
          message: "Erro ao salvar produtos",
          position: "bottom",
          timeout: 3000,
        });
      } finally {
        salvandoProduto.value = false;
      }
    };

    const removerProduto = (produto) => {
      quasar
        .dialog({
          title: "Confirmar",
          message: `Deseja remover o produto ${produto.descricao}?`,
          cancel: true,
          persistent: true,
        })
        .onOk(async () => {
          try {
            const contratoId = route.params.id;

            await store.dispatch("gdcStore/removerProdutoContrato", {
              contratoId,
              produtoId: produto.id,
            });

            await carregarProdutos();

            quasar.notify({
              type: "positive",
              message: "Produto removido com sucesso!",
              position: "bottom",
              timeout: 3000,
            });
          } catch (error) {
            console.error("Erro ao remover produto:", error);
            quasar.notify({
              type: "negative",
              message: "Erro ao remover produto",
              position: "bottom",
              timeout: 3000,
            });
          }
        });
    };

    const abrirModalEdicaoProduto = (produto) => {
      produtoEdicao.value = produto;
      formEdicaoProduto.value = {
        measurementUnit: produto.unidadeMedida,
        amount: produto.quantidade,
        unitaryValue: parseFloat(produto.valorUnitario || 0).toLocaleString(
          "pt-BR",
          {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }
        ),
      };
      modalEdicaoProduto.value = true;
    };

    const fecharModalEdicaoProduto = () => {
      modalEdicaoProduto.value = false;
      produtoEdicao.value = null;
      formEdicaoProduto.value = {
        measurementUnit: "",
        amount: 0,
        unitaryValue: 0,
      };
    };

    const salvarEdicaoProduto = async () => {
      try {
        salvandoProduto.value = true;
        const contratoId = route.params.id;

        await store.dispatch("gdcStore/editarProdutoContrato", {
          contratoId,
          produtoId: produtoEdicao.value.id,
          produtoData: {
            measurementUnit: formEdicaoProduto.value.measurementUnit,
            amount: formEdicaoProduto.value.amount,
            unitaryValue: parseCurrency(formEdicaoProduto.value.unitaryValue),
          },
        });

        quasar.notify({
          type: "positive",
          message: "Produto atualizado com sucesso!",
          position: "bottom",
          timeout: 3000,
        });

        fecharModalEdicaoProduto();
        await carregarProdutos();
      } catch (error) {
        console.error("Erro ao salvar produto:", error);
        quasar.notify({
          type: "negative",
          message: "Erro ao salvar produto",
          position: "bottom",
          timeout: 3000,
        });
      } finally {
        salvandoProduto.value = false;
      }
    };

    const validarFormEdicao = () => {
      return (
        formEdicaoProduto.value.measurementUnit &&
        formEdicaoProduto.value.amount > 0 &&
        parseCurrency(formEdicaoProduto.value.unitaryValue) > 0
      );
    };

    const voltarParaListagem = () => {
      router.push({ name: "gestao-contratos-listagem" });
    };

    const receberFornecedor = (fornecedor) => {
      fornecedorSelecionado.value = fornecedor;
      // Atualizar os dados computados do fornecedor
      if (fornecedor) {
        contrato.value.provider = {
          id: fornecedor.id,
          fantasyName: fornecedor.fantasyName,
          businessName: fornecedor.businessName,
          cnpj: fornecedor.cnpj,
        };
      }
    };

    const formatarMoeda = (valor) => {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(parseFloat(valor.toString().replace(",", ".")) || 0);
    };

    const formatarData = (data) => {
      return new Date(data).toLocaleDateString("pt-BR");
    };

    const formatarDataHora = (data) => {
      return (
        new Date(data).toLocaleDateString("pt-BR") +
        " " +
        new Date(data).toLocaleTimeString("pt-BR", {
          hour: "2-digit",
          minute: "2-digit",
        })
      );
    };

    const formatAction = (action) => {
      const actionMap = {
        CREATE_CONTRACT: "Criado",
        LINK_VENDOR: "Vincular Fornecedor",
        UNLINK_VENDOR: "Desvincular Fornecedor",
        ADD_PRODUCT: "Adicionar Produto",
        EDIT_PRODUCT: "Editar Produto",
        REMOVE_PRODUCT: "Remover Produto",
        UPDATE_CONTRACT: "Atualizar Contrato",
        DELETE_CONTRACT: "Excluir Contrato",
      };
      return actionMap[action] || action;
    };

    const getActionColor = (action) => {
      const colorMap = {
        CREATE_CONTRACT: "positive",
        LINK_VENDOR: "info",
        UNLINK_VENDOR: "warning",
        ADD_PRODUCT: "positive",
        EDIT_PRODUCT: "info",
        REMOVE_PRODUCT: "negative",
        UPDATE_CONTRACT: "primary",
        DELETE_CONTRACT: "negative",
      };
      return colorMap[action] || "grey";
    };

    // Lifecycle
    onMounted(() => {
      carregarContrato();
      carregarSupplies();
      carregarProdutos();
    });

    // Watcher para detectar quando uma unidade é desmarcada
    watch(
      () => [...unidadesSelecionadas.value], // Cria uma cópia para detectar mudanças
      async (novasSelecoes, selecoesAnteriores) => {
        if (!selecoesAnteriores || !modalUnidades.value) return;

        // Encontrar unidades que foram desmarcadas
        const unidadesDesmarcadas = selecoesAnteriores.filter(
          (id) => !novasSelecoes.includes(id)
        );

        // Desvincular unidades que foram desmarcadas e estavam previamente vinculadas
        for (const unidadeId of unidadesDesmarcadas) {
          const unidadeVinculada = unidadesVinculadas.value.find(
            (u) => u.id === unidadeId
          );

          if (unidadeVinculada) {
            try {
              const contratoId = route.params.id;
              await store.dispatch("gdcStore/desvincularVendorContrato", {
                contratoId,
                vendorsIds: [unidadeId],
              });

              // Recarregar dados do contrato
              await carregarContrato();

              quasar.notify({
                type: "positive",
                message: `Unidade ${unidadeVinculada.name} desvinculada com sucesso!`,
                position: "bottom",
                timeout: 3000,
              });
            } catch (error) {
              console.error("Erro ao desvincular unidade:", error);

              // Em caso de erro, reverter a seleção
              unidadesSelecionadas.value.push(unidadeId);

              quasar.notify({
                type: "negative",
                message: "Erro ao desvincular unidade",
                position: "bottom",
                timeout: 3000,
              });
            }
          }
        }
      }
    );

    // Watch para carregar dados quando a tab ativa mudar
    const watchActiveTab = (newTab) => {
      if (newTab === "produtos") {
        carregarProdutos();
      } else if (newTab === "historico") {
        carregarHistorico();
      } else if (newTab === "unidades") {
        carregarContrato();
      } else if (newTab === "anexos") {
        if (temPermissaoListar.value) {
          buscarAnexos();
        }
      }
    };

    // Carregar lista de tipos de fornecimento
    const carregarSupplies = async (val) => {
      try {
        const response = await store.dispatch("gdcStore/getSupplies", {
          name: val,
        });
        suppliesOptions.value = response.data.result.data || [];
      } catch (error) {
        console.error("Erro ao carregar tipos de fornecimento:", error);
      }
    };

    const handleRequest = async () => {
      buscarProdutosEstoque(
        pagination.value.page,
        pagination.value.rowsPerPage
      );
    };

    watch(
      () => pagination.value.page,
      () => {
        handleRequest();
      }
    );

    watchDebounced(
      () => filtrosProdutos.value,
      () => {
        handleRequest();
      },
      { debounce: 1000, deep: true }
    );

    const filterFn = (val, update) => {
      clearTimeout(time.value);
      time.value = setTimeout(() => {
        update(async () => {
          await carregarSupplies(val);
        });
      }, 300);
    };

    // Dados para anexos
    const anexos = ref([]);
    const loadingAnexos = ref(false);
    const modalUploadAnexo = ref(false);
    const modalDeleteAnexo = ref(false);
    const anexoParaDeletar = ref(null);
    const filtroAnexos = ref({
      fileName: "",
    });
    const paginacaoAnexos = ref({
      page: 1,
      perPage: 10,
      total: 0,
    });
    const formUploadAnexo = ref({
      arquivo: null,
      nomeArquivo: "",
      descricao: "",
      arquivoBase64: "",
    });

    // Permissões para anexos - validadas através das permissões do usuário
    const temPermissaoUpload = computed(() => {
      const roles =
        store.state.autenticacao?.usuarioLogado?.permissoes?.gmapi?.roles || [];
      return roles.includes("gc-contrato-adicionar-arquivo");
    });

    const temPermissaoListar = computed(() => {
      const roles =
        store.state.autenticacao?.usuarioLogado?.permissoes?.gmapi?.roles || [];
      return roles.includes("gc-contrato-listar-arquivos");
    });

    const temPermissaoDeletar = computed(() => {
      const roles =
        store.state.autenticacao?.usuarioLogado?.permissoes?.gmapi?.roles || [];
      return roles.includes("gc-contrato-deletar-arquivo");
    });

    // Métodos para anexos
    const buscarAnexos = async (event = null) => {
      if (!temPermissaoListar.value) {
        quasar.notify({
          type: "negative",
          message: "Você não tem permissão para listar arquivos",
          position: "bottom",
          timeout: 3000,
        });
        return;
      }

      try {
        loadingAnexos.value = true;
        const contratoId = route.params.id;

        if (event) {
          paginacaoAnexos.value.page = event.pagination.page;
          paginacaoAnexos.value.perPage = event.pagination.rowsPerPage;
        }

        const params = {
          contratoId,
          fileName: filtroAnexos.value.fileName || undefined,
          perPage: paginacaoAnexos.value.perPage,
          page: paginacaoAnexos.value.page,
        };

        const response = await store.dispatch(
          "gdcStore/getContratoAnexos",
          params
        );

        if (response.data.result) {
          anexos.value = response.data.result.data || [];
          paginacaoAnexos.value = {
            page: response.data.result.currentPage || 1,
            perPage: response.data.result.perPage || 10,
            total: response.data.result.total || 0,
          };
        } else {
          anexos.value = [];
        }
      } catch (error) {
        console.error("❌ Erro ao buscar anexos:", error);
        anexos.value = [];

        // Verificar se é erro de permissão
        if (error.response?.status === 403) {
          quasar.notify({
            type: "negative",
            message: "Você não tem permissão para listar arquivos",
            position: "bottom",
            timeout: 3000,
          });
        } else {
          // Mostrar detalhes do erro
          const errorMsg =
            error.response?.data?.message ||
            error.message ||
            "Erro ao buscar anexos do contrato";
          quasar.notify({
            type: "negative",
            message: errorMsg,
            position: "bottom",
            timeout: 5000,
          });
        }
      } finally {
        loadingAnexos.value = false;
      }
    };

    const abrirModalUpload = () => {
      if (!temPermissaoUpload.value) {
        quasar.notify({
          type: "negative",
          message: "Você não tem permissão para fazer upload de arquivos",
          position: "bottom",
          timeout: 3000,
        });
        return;
      }

      // Resetar formulário
      formUploadAnexo.value = {
        arquivo: null,
        nomeArquivo: "",
        descricao: "",
        arquivoBase64: "",
      };

      modalUploadAnexo.value = true;
    };

    const converterArquivoBase64 = (arquivo) => {
      return new Promise((resolve, reject) => {
        if (!arquivo) {
          reject(new Error("Nenhum arquivo fornecido"));
          return;
        }

        const reader = new FileReader();
        reader.onload = () => {
          resolve(reader.result);
        };
        reader.onerror = () => {
          reject(new Error("Erro ao ler o arquivo"));
        };
        reader.readAsDataURL(arquivo);
      });
    };

    const uploadAnexo = async () => {
      try {
        if (!formUploadAnexo.value.arquivo) {
          quasar.notify({
            type: "negative",
            message: "Selecione um arquivo para enviar",
            position: "bottom",
            timeout: 3000,
          });
          return;
        }

        if (!formUploadAnexo.value.nomeArquivo.trim()) {
          quasar.notify({
            type: "negative",
            message: "Nome do arquivo é obrigatório",
            position: "bottom",
            timeout: 3000,
          });
          return;
        }

        loadingAnexos.value = true;

        // Converter arquivo para base64
        const arquivoBase64 = await converterArquivoBase64(
          formUploadAnexo.value.arquivo
        );

        const contratoId = route.params.id;
        const payload = {
          contratoId,
          fileName: formUploadAnexo.value.nomeArquivo,
          fileBase64: arquivoBase64,
          description: formUploadAnexo.value.descricao || undefined,
        };

        await store.dispatch("gdcStore/uploadContratoAnexo", payload);

        quasar.notify({
          type: "positive",
          message: "Anexo enviado com sucesso!",
          position: "bottom",
          timeout: 3000,
        });

        modalUploadAnexo.value = false;
        await buscarAnexos();
      } catch (error) {
        console.error("Erro ao fazer upload do anexo:", error);

        // Verificar diferentes tipos de erro
        if (error.response?.status === 403) {
          quasar.notify({
            type: "negative",
            message: "Você não tem permissão para adicionar arquivos",
            position: "bottom",
            timeout: 3000,
          });
        } else if (error.response?.status === 400) {
          quasar.notify({
            type: "negative",
            message:
              "Dados do arquivo inválidos. Verifique o nome e o formato.",
            position: "bottom",
            timeout: 3000,
          });
        } else if (error.response?.status === 404) {
          quasar.notify({
            type: "negative",
            message: "Contrato não encontrado",
            position: "bottom",
            timeout: 3000,
          });
        } else {
          quasar.notify({
            type: "negative",
            message: "Erro ao fazer upload do anexo",
            position: "bottom",
            timeout: 3000,
          });
        }
      } finally {
        loadingAnexos.value = false;
      }
    };

    const downloadAnexo = async (anexo) => {
      try {
        if (!anexo.url) {
          quasar.notify({
            type: "negative",
            message: "URL de download não disponível",
            position: "bottom",
            timeout: 3000,
          });
          return;
        }

        const link = document.createElement("a");
        link.href = anexo.url;
        link.download = anexo.name || `anexo_${anexo.id}`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        quasar.notify({
          type: "positive",
          message: "Download iniciado",
          position: "bottom",
          timeout: 2000,
        });
      } catch (error) {
        console.error("Erro ao fazer download do anexo:", error);
        quasar.notify({
          type: "negative",
          message: "Erro ao fazer download do arquivo",
          position: "bottom",
          timeout: 3000,
        });
      }
    };

    const confirmarDeleteAnexo = (anexo) => {
      if (!temPermissaoDeletar.value) {
        quasar.notify({
          type: "negative",
          message: "Você não tem permissão para deletar arquivos",
          position: "bottom",
          timeout: 3000,
        });
        return;
      }

      anexoParaDeletar.value = anexo;

      quasar
        .dialog({
          title: "Confirmar Exclusão",
          message: `Tem certeza que deseja deletar o anexo "${anexo.name}"? Essa ação é irreversível.`,
          cancel: {
            label: "Cancelar",
            color: "grey",
            flat: true,
          },
          ok: {
            label: "Deletar",
            color: "negative",
          },
          persistent: true,
        })
        .onOk(() => {
          deletarAnexo();
        });
    };

    const deletarAnexo = async () => {
      try {
        if (!anexoParaDeletar.value) return;

        loadingAnexos.value = true;
        const contratoId = route.params.id;

        await store.dispatch("gdcStore/deletarContratoAnexo", {
          contratoId,
          fileId: anexoParaDeletar.value.id,
        });

        quasar.notify({
          type: "positive",
          message: "Anexo deletado com sucesso!",
          position: "bottom",
          timeout: 3000,
        });

        await buscarAnexos();
      } catch (error) {
        console.error("Erro ao deletar anexo:", error);

        // Verificar diferentes tipos de erro
        if (error.response?.status === 403) {
          quasar.notify({
            type: "negative",
            message: "Você não tem permissão para deletar arquivos",
            position: "bottom",
            timeout: 3000,
          });
        } else if (error.response?.status === 404) {
          quasar.notify({
            type: "negative",
            message: "Arquivo não encontrado",
            position: "bottom",
            timeout: 3000,
          });
        } else {
          quasar.notify({
            type: "negative",
            message: "Erro ao deletar anexo",
            position: "bottom",
            timeout: 3000,
          });
        }
      } finally {
        loadingAnexos.value = false;
        anexoParaDeletar.value = null;
      }
    };

    const getFileIcon = (extension) => {
      if (!extension) return "description";

      const ext = extension.toLowerCase();
      const iconMap = {
        // Documentos PDF
        pdf: "picture_as_pdf",
        // Imagens
        jpg: "image",
        jpeg: "image",
        png: "image",
        gif: "image",
        bmp: "image",
        svg: "image",
        // Documentos Office
        doc: "description",
        docx: "description",
        xls: "grid_on",
        xlsx: "grid_on",
        ppt: "slideshow",
        pptx: "slideshow",
        // Texto
        txt: "text_snippet",
        rtf: "text_snippet",
        // Compactados
        zip: "folder_zip",
        rar: "folder_zip",
        "7z": "folder_zip",
        // Outros
        csv: "grid_on",
      };

      return iconMap[ext] || "description";
    };

    const getFileIconColor = (extension) => {
      if (!extension) return "grey-6";

      const ext = extension.toLowerCase();
      const colorMap = {
        // PDF - vermelho
        pdf: "red-6",
        // Imagens - verde
        jpg: "green-6",
        jpeg: "green-6",
        png: "green-6",
        gif: "green-6",
        bmp: "green-6",
        svg: "green-6",
        // Office - azul
        doc: "blue-6",
        docx: "blue-6",
        xls: "teal-6",
        xlsx: "teal-6",
        ppt: "orange-6",
        pptx: "orange-6",
        // Texto - cinza
        txt: "grey-7",
        rtf: "grey-7",
        // Compactados - roxo
        zip: "purple-6",
        rar: "purple-6",
        "7z": "purple-6",
        // CSV - verde escuro
        csv: "green-8",
      };

      return colorMap[ext] || "grey-6";
    };

    // Funções auxiliares para o modal de upload
    const onRejected = (rejectedEntries) => {
      // Quando arquivo é rejeitado (tamanho muito grande, etc)
      const reasons = rejectedEntries.map((entry) => {
        if (entry.failedPropValidation === "max-file-size") {
          return "Arquivo muito grande (máximo 10MB)";
        }
        return "Arquivo rejeitado";
      });

      quasar.notify({
        type: "negative",
        message: `Arquivo rejeitado: ${reasons.join(", ")}`,
        position: "bottom",
        timeout: 3000,
      });
    };

    const onFileSelected = (file) => {
      // Quando um arquivo é selecionado, preencher automaticamente o nome se estiver vazio
      if (file && !formUploadAnexo.value.nomeArquivo) {
        // Remover a extensão do nome original para sugerir um nome
        const nomeOriginal = file.name;
        const nomeWithoutExtension =
          nomeOriginal.substring(0, nomeOriginal.lastIndexOf(".")) ||
          nomeOriginal;
        formUploadAnexo.value.nomeArquivo = nomeWithoutExtension;
      }
    };

    const formatarTamanhoArquivo = (bytes) => {
      if (!bytes) return "0 Bytes";

      const k = 1024;
      const sizes = ["Bytes", "KB", "MB", "GB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));

      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
    };

    const onFileSelectedModal = (event) => {
      const file = event.target.files[0];
      if (file) {
        formUploadAnexo.value.arquivo = file;

        if (!formUploadAnexo.value.nomeArquivo) {
          const nomeOriginal = file.name;
          const nomeWithoutExtension =
            nomeOriginal.substring(0, nomeOriginal.lastIndexOf(".")) ||
            nomeOriginal;
          formUploadAnexo.value.nomeArquivo = nomeWithoutExtension;
        }
      }
    };

    const resetFileInput = () => {
      const input = document.getElementById("arquivo-anexo");
      if (input) {
        input.value = "";
      }
    };

    const triggerFileInput = () => {
      const input = document.getElementById("arquivo-anexo");
      if (input) {
        input.click();
      }
    };

    const onDragOver = (event) => {
      event.preventDefault();
      event.currentTarget.style.backgroundColor = "#e3f2fd";
    };

    const onDragLeave = (event) => {
      event.preventDefault();
      event.currentTarget.style.backgroundColor = "";
    };

    const onDrop = (event) => {
      event.preventDefault();
      event.currentTarget.style.backgroundColor = "";

      const files = event.dataTransfer.files;
      if (files.length > 0) {
        const file = files[0];
        formUploadAnexo.value.arquivo = file;

        if (!formUploadAnexo.value.nomeArquivo) {
          const nomeOriginal = file.name;
          const nomeWithoutExtension =
            nomeOriginal.substring(0, nomeOriginal.lastIndexOf(".")) ||
            nomeOriginal;
          formUploadAnexo.value.nomeArquivo = nomeWithoutExtension;
        }
      }
    };

    return {
      // Estados
      loading,
      salvando,
      loadingProdutos,
      loadingHistorico,
      salvandoProduto,
      edicaoHabilitada,
      activeTab,
      modalUnidades,
      modalProduto,
      suppliesOptions,
      loadingBuscaProdutos,

      // Dados
      contrato,
      vendorName,
      vendorCnpj,
      userName,
      userSap,
      labelProdutosSelecionados,
      unidadesVinculadas,
      produtos,
      historico,
      produtosDisponiveis,
      produtoEdicao,
      formProduto,
      fornecedorSelecionado,

      // Novos dados para modal produtos
      produtosEstoque,
      produtosSelecionados,
      filtrosProdutos,
      gruposOptions,
      categoriasOptions,

      // Novos dados para modal unidades
      carregandoUnidades,
      unidadesDisponiveis,
      unidadesSelecionadas,
      filtroUnidades,
      unidadesFiltradas,
      filterFn,
      time,

      // Colunas
      unidadesColumns,
      produtosColumns,
      historicoColumns,
      produtosEstoqueColumns,
      anexosColumns,

      // Métodos
      toggleEdicao,
      cancelarEdicao,
      validarFormulario,
      salvarContrato,
      abrirModalUnidades,
      carregarUnidadesDisponiveis,
      salvarVinculoUnidades,
      desvincularUnidade,
      abrirModalProduto,
      fecharModalProduto,
      salvarProduto,
      salvarProdutosSelecionados,
      removerProduto,
      voltarParaListagem,
      receberFornecedor,
      formatarMoeda,
      formatarData,
      formatarDataHora,
      formatAction,
      getActionColor,

      // Novos métodos
      buscarProdutosEstoque,
      isProdutoSelecionado,
      formatarValorUnitario,
      formatarValorUnitarioFinal,
      filterGrupos,
      filterCategorias,
      formatarValorBrasileiro,
      formatarInput,
      formatarValorFinal,
      formatarInputEdicaoUnitario,
      formatarUnitarioFinal,
      parseCurrency,
      formatarQuantidade,
      getEstoqueColor,
      getQuantidadeDisponivelColor,
      getValorDisponivelColor,
      limparFiltros,

      // Watch
      watchActiveTab,
      confirmarDesvinculoUnidade,
      modalDesvincularUnidade,
      unidadeParaDesvincular,

      //pagination
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      pagination,
      handleRequest,

      // Modal edição produto
      modalEdicaoProduto,
      formEdicaoProduto,
      abrirModalEdicaoProduto,
      fecharModalEdicaoProduto,
      salvarEdicaoProduto,
      validarFormEdicao,

      // Dados para anexos
      anexos,
      loadingAnexos,
      modalUploadAnexo,
      modalDeleteAnexo,
      anexoParaDeletar,
      filtroAnexos,
      paginacaoAnexos,
      formUploadAnexo,

      // Permissões para anexos
      temPermissaoUpload,
      temPermissaoListar,
      temPermissaoDeletar,

      // Métodos para anexos
      buscarAnexos,
      abrirModalUpload,
      uploadAnexo,
      downloadAnexo,
      confirmarDeleteAnexo,
      deletarAnexo,
      getFileIcon,
      getFileIconColor,
      converterArquivoBase64,
      onRejected,
      onFileSelected,
      formatarTamanhoArquivo,
      onFileSelectedModal,
      resetFileInput,
      triggerFileInput,
      onDragOver,
      onDragLeave,
      onDrop,
    };
  },

  watch: {
    activeTab(newVal) {
      this.watchActiveTab(newVal);
    },
  },
};
</script>

<style>
.q-field--outlined.q-field--readonly .q-field__control:before {
  border-style: inset;
  border-width: 1px;
  border-color: rgba(0, 0, 0, 0.24);
}

.input-field .q-field__native {
  cursor: text !important;
}

.input-field .q-field__input {
  cursor: text !important;
}

.input-field .q-field__native span {
  cursor: text !important;
}

.q-expansion-item .disabled {
  opacity: 1 !important;
}
.q-expansion-item .disabled .input-q-field__native input {
  cursor: pointer !important;
}
</style>

<style scoped>
.q-expansion-item .disabled .input-q-field__native input {
  cursor: pointer !important;
}

.input-new-design {
  margin-bottom: 16px;
}

.input-label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  margin-bottom: 8px;
}

.input-field {
  background-color: #f9fafb;
}

.input-field .q-field__control {
  border-radius: 8px;
}

.custom-table {
  box-shadow: none;
}

.custom-table .q-table__top,
.custom-table .q-table__bottom {
  border: none;
}

.custom-table thead tr:first-child th {
  background-color: #f3f4f6;
  font-weight: 600;
  color: #374151;
}

.custom-table tbody tr:hover {
  background-color: #f9fafb;
}

.tabela-produtos-estoque {
  box-shadow: none;
}

.tabela-produtos-estoque .q-table__top,
.tabela-produtos-estoque .q-table__bottom {
  border: none;
}

.tabela-produtos-estoque thead tr:first-child th {
  background-color: #e3f2fd;
  font-weight: 600;
  color: #1976d2;
}

.tabela-produtos-estoque tbody tr:hover {
  background-color: #f3f4f6;
}

.tabela-produtos-estoque .q-table__selected {
  background-color: #e8f5e8;
}

.q-timeline__content {
  padding-left: 16px;
}

.upload-area-interactive {
  border: 2px dashed #7ab9e0;
  border-radius: 12px;
  padding: 40px 20px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  background-color: #f8f9fa;
  min-height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.upload-area-interactive:hover {
  background-color: #e3f2fd;
  border-color: #1976d2;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.upload-zone-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  width: 100%;
}

.upload-icon {
  margin-bottom: 8px;
  opacity: 0.8;
}

.upload-text-primary {
  font-size: 16px;
  font-weight: 600;
  color: #1976d2;
  text-align: center;
  line-height: 1.4;
}

.upload-text-secondary {
  font-size: 12px;
  color: #6c757d;
  text-align: center;
  opacity: 0.8;
}

.selected-file-info {
  margin-top: 16px;
  padding: 8px 12px;
  background-color: #e8f5e9;
  border-radius: 6px;
  font-size: 14px;
  color: #2e7d32;
  display: flex;
  align-items: center;
  justify-content: center;
}

.selected-file-name {
  font-weight: 600;
  margin-left: 4px;
}

/* Responsive para área de upload */
@media (max-width: 600px) {
  .upload-area-interactive {
    padding: 30px 16px;
    min-height: 100px;
  }

  .upload-text-primary {
    font-size: 14px;
  }

  .upload-text-secondary {
    font-size: 11px;
  }
}
</style>
